<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="item.id ? 'Update' : 'Create'"
    :min-width="800"
  >
    <template slot="header">
      <span>{{ item.id ? 'Update Notification' : 'Create Notification' }}</span>
    </template>
    <template slot="body">
      <div class="d-flex flex-column">
        <span>Notifications will be sent for every update related to the assigned module. Users linked to the module will receive these emails</span>
        <div class="d-flex flex-column ga-2 pt-3">
          <span
            class="fw500"
            style="color: #000; font-size: 18px"
          >Name<RedAsterisk /></span>
          <v-text-field
            v-model="item.name"
            outlined
            clearable
            placeholder="Enter Name"
            :rules="[(v) => !!v || `Name is required`]"
          />
        </div>
        <div />
        <div class="d-flex flex-column ga-2">
          <span
            class="fw500"
            style="color: #000; font-size: 18px"
          >Module<RedAsterisk /></span>
          <v-autocomplete
            v-model="item.type_id"
            :items="types"
            item-text="name"
            item-value="id"
            clearable
            outlined
            placeholder="Select notification module"
            :rules="[(v) => !!v || `Module is required`]"
          />
        </div>
        <div class="d-flex flex-column ga-2">
          <span
            class="fw500"
            style="color: #000; font-size: 18px"
          >Users<RedAsterisk /></span>
          <v-autocomplete
            v-model="item.user_ids"
            :items="users"
            :item-text="(user) => `${user.first_name} ${user.last_name}`"
            item-value="id"
            clearable
            outlined
            multiple
            placeholder="Select Users that will receive notifications"
            :rules="[(v) => !!v || `At least one user is required`]"
          />
        </div>
      </div>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  components: {

  },
  props: {

  },
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      name: null,
      type_id: null,
      user_ids: [],
    },
    types: [],
    users: [],
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  watch: {

  },
  created() {
    this.item = { ...this.itemDto };
    this.getUsers();
    this.getTypes();
  },
  methods: {

    async get(id) {
      if (!id) return;
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.notificationTemplate.read(submitModel);
      if (!res || res.length < 1 || !res[0]) return;
      const firstIndex = 0;
      this.item = res[firstIndex];
    },

    async getTypes() {
      this.types = await this.$api.notificationTemplateType.get();
    },

    async getUsers() {
      const submitModel = {
        filters: {
          is_username: false,
        },
      };
      const res = await this.$api.user.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) {
        return;
      }
      if (res.length <= 0) {
        return;
      }
      this.users = res;
    },

    async submit() {
      if (!this.item) return false;
      let res;
      if (this.item.id) {
        res = await this.$api.notificationTemplate.update(this.item);
      } else {
        res = await this.$api.notificationTemplate.store(this.item);
      }

      if (!res) {
        this.$bus.$emit('showError', 'Record with this module already exists');
        return false;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    open(id) {
      if (id) {
        this.item.id = id;
        this.get(id);
      } else {
        this.item = { ...this.itemDto };
      }
      this.$refs.dialogBox.open();
    },
  },
};
</script>
